import { ConnectorFlowInstanceDTO } from '@/models/connectors';
import { FC, useState } from 'react';
import { ConnectorFlowInstanceDetailsModal } from '../modals/ConnectorFlowInstanceDetailsModal';

type CustomConnectorResourceColumnProps = {
  flowInstance: ConnectorFlowInstanceDTO;
};

export const CustomConnectorResourceColumn: FC<CustomConnectorResourceColumnProps> = ({ flowInstance }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button onClick={() => setShowModal(true)} className='text-sm text-blue-600 hover:text-blue-800 underline focus:outline-none'>
        More details
      </button>
      {showModal && <ConnectorFlowInstanceDetailsModal flowInstance={flowInstance} closeModal={() => setShowModal(false)} />}
    </>
  );
};
